module.exports = __webpack_public_path__ + "static/agriculture-drone-field-c6bb6d79091f0cad3e09f7181ee33693.jpg";